import { render, staticRenderFns } from "./HotelExtraList.vue?vue&type=template&id=55dbcbba&"
import script from "./HotelExtraList.vue?vue&type=script&lang=js&"
export * from "./HotelExtraList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports